import { render, staticRenderFns } from "./Masterpass.vue?vue&type=template&id=48b3801e&scoped=true&"
import script from "./Masterpass.vue?vue&type=script&lang=js&"
export * from "./Masterpass.vue?vue&type=script&lang=js&"
import style0 from "./Masterpass.vue?vue&type=style&index=0&id=48b3801e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b3801e",
  null
  
)

export default component.exports